/**
 * Blog posts. Each post gets a prerendered page at /blog/:slug.
 *
 * Shape:
 * {
 *   slug: 'desk-worker-stretches',
 *   title: '5 Stretches Every Desk Worker Should Know',
 *   description: '≤155 character meta description',
 *   excerpt: 'One or two sentences for the card',
 *   authorSlug: 'jazmin-ulalan',           // must match team.js
 *   date: '2026-10-01',                    // ISO date published
 *   updated: '2026-10-01',                 // optional ISO date modified
 *   category: 'Desk Workers',
 *   image: '/blog/desk-worker-stretches.jpg',
 *   readTime: '5 min read',
 *   relatedServices: ['massage-therapy'],  // servicePages slugs
 *   relatedConditions: ['desk-worker-pain'],
 *   body: [
 *     { heading: 'Why it matters', paragraphs: ['...'] },
 *   ],
 *   reviewed: false,                       // true once the author signs off
 * }
 */

export const blogPosts = []
